export const getCurrentUser = state => state.app.user;
export const getUserRole = state => state.app.userRole;
export const getAppRole = state => state.app.appRole;
////
export const getUsers = state => Object.values(state.app.users);
export const getUserById = (state, id) => state.app.users[id];
////
export const getAccounts = state => state.account.ids.map(id => state.account.store[id]);
export const getAccount = (state, id) => state.account.store[id];
////
export const getGroups = state => state.group.ids.map(id => state.group.store[id]);
export const getGroup = (state, id) => state.group.store[id];
////
export const getTags = state => state.tag.ids.map(id => state.tag.store[id]);
export const getTag = (state, id) => state.tag.store[id];
////
export const getBankAccounts = state => state.bankAccount.ids.map(id => state.bankAccount.store[id]);
export const getBankAccount = (state, id) => state.bankAccount.store[id];
////
export const getAllItems = state => state.item.allIds.map(id => state.item.store[id]);
export const getDisplayItems = state => state.item.ids.map(id => state.item.store[id]);
export const getItemById = (state, id) => state.item.store[id];
////
export const getAllSuppliers = state => state.contact.allIds.map(id => state.contact.store[id]).filter(o => o.is_supplier);
export const getSupplierById = (state, id) => state.contact.store[id];

export const getAllCustomers = state => state.contact.allIds.map(id => state.contact.store[id]).filter(o => o.is_customer);
export const getCustomerById = (state, id) => state.contact.store[id];

export const getAllContacts = state => state.contact.allIds.map(id => state.contact.store[id]);
export const getDisplayContacts = state => state.contact.ids.map(id => state.contact.store[id]);
export const getContactById = (state, id) => state.contact.store[id];
////
export const getAllItemUnits = state => state.itemUnit.ids.map(id => state.itemUnit.store[id]);
export const getItemUnitById = (state, id) => state.itemUnit.store[id];
////
export const getAllEmployees = state => state.employee.allIds.map(id => state.employee.store[id]);
export const getDisplayEmployees = state => state.employee.ids.map(id => state.employee.store[id]);
export const getEmployeeById = (state, id) => state.employee.store[id];
////
export const isInBeginPeriod = state => state.app.accountingPeriod === state.app.beginPeriod;
export const getAsyncStatus = (state, action) => state.loading.effects[action] && state.loading.effects[action].status;
////
export const getNotifications = state => state.notification.notifications;
export const getActivities = state => state.notification.activities;
export const hasMoreActivities = state => state.notification.hasMoreActivities;
export const hasUnreadNotification = state => state.notification.unreadNotificationCount > 0;
export const getUnreadNotificationCount = state => state.notification.unreadNotificationCount || 0;
////
export const getSetting = (state, key) => state.app.settings[key];
export const multipleCurrencies = state => !!state.app.settings.foreign_currency;
export const foreignCurrencies = state => state.app.settings.foreign_currency || [];
////
export const getFileTags = state => state.fileTag.ids.map(id => state.fileTag.store[id]);
export const getFileTag = (state, id) => state.fileTag.store[id];
////
export const getComments = state => state.comment.list.map(id => state.comment.store[id]);
export const hasMoreComments = state => state.comment.hasMoreComments;
export const getCommentsInStream = (state, streamId) => state.comment.stream[streamId] && state.comment.stream[streamId].topIds.map(id => state.comment.store[id]);
export const getLatestComments = state => state.comment.latest.map(id => state.comment.store[id]);
export const getStarredComments = state => state.comment.starred.map(id => state.comment.store[id]);
////
export const getExpenseDistributions = state => state.expenseDistribution.ids.map(id => state.expenseDistribution.store[id]);
////
export const getSpaceData = state => state.space.list.map(id => state.space.store[id]);



// WEBPACK FOOTER //
// ./src/selectors/index.js